var $9c5c9f0ea54ee443$exports = {};
$9c5c9f0ea54ee443$exports = {
    "more": `Daha fazla \xf6\u{11F}e`
};


export {$9c5c9f0ea54ee443$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
